// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".geo-modal[data-v-d19f5112]{width:500px}", ""]);
// Exports
module.exports = exports;
